import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/perfil/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/perfil/editar", replace: true });
  }
});
